module.exports = __webpack_public_path__ + "img/friendlydragon.c60c5973.jpg";